import { Outlet } from "react-router-dom";

function ReturnsMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default ReturnsMain;